import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldAlert, X } from "lucide-react";
import { formatPrice } from "@/lib/equipment";

const CONSEQUENCES = [
  "1 · CONFISCATED — goods gone, +3d6×100¤ fine to your DEBT.",
  "2 · CORP MERCS — a hit squad is on your tail for the session.",
  "3 · PARANOIA — +1 GLITCH from the constant looking-over-your-shoulder.",
  "4 · DETAINED — item lost, one in-game day burned in a holding cell.",
  "5 · BOUNTY — every scanner in Cy pings your face. DR14 Presence to lie low.",
  "6 · LEFT TO ROT — the enforcers make an example. d4 damage + DEBT +d6×100¤.",
];

export default function IllegalWarningModal({ open, item, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[110] flex items-center justify-center p-4" data-testid="illegal-warning-modal">
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="absolute inset-0 bg-black/90 backdrop-blur-sm"
          onClick={onCancel}
        />
        <motion.div
          initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 20, opacity: 0 }}
          transition={{ type: "spring", damping: 22 }}
          className="relative panel panel-magenta p-6 w-full max-w-lg"
        >
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-3">
              <ShieldAlert className="text-[color:var(--accent-magenta)]" />
              <div className="font-display uppercase font-black tracking-tight text-xl leading-tight">
                CONTRABAND ADVISORY
              </div>
            </div>
            <button data-testid="illegal-cancel-x" onClick={onCancel} aria-label="Close" className="p-1 hover:text-[color:var(--accent-yellow)]">
              <X size={18} />
            </button>
          </div>

          <div className="font-mono text-xs text-[color:var(--text-secondary)] uppercase tracking-widest mb-3">
            You're buying:
          </div>
          {item && (
            <div className="border-2 border-[color:var(--accent-yellow)] p-3 mb-4 flex items-center justify-between">
              <div>
                <div className="font-display font-black uppercase text-lg leading-tight">{item.name}</div>
                <div className="text-[10px] font-mono uppercase tracking-widest text-[color:var(--text-muted)]">
                  Category · {item.category}
                </div>
              </div>
              <div className="tape text-[11px]">{formatPrice(item.price || 0)}</div>
            </div>
          )}

          <div className="text-[10px] font-mono uppercase tracking-widest text-[color:var(--text-muted)] mb-2">
            IF YOU GET CAUGHT (GM rolls d6):
          </div>
          <div className="border-2 border-dashed border-[color:var(--border-hard)] p-3 mb-4 max-h-[220px] overflow-y-auto">
            {CONSEQUENCES.map((c, i) => (
              <div key={i} className="text-xs font-mono text-[color:var(--text-secondary)] mb-1 leading-snug">{c}</div>
            ))}
          </div>

          <div className="flex gap-2 justify-end">
            <button data-testid="illegal-cancel-btn" onClick={onCancel} className="cy-btn cy-btn-cyan text-xs">
              CANCEL
            </button>
            <button data-testid="illegal-confirm-btn" onClick={onConfirm} className="cy-btn cy-btn-magenta text-xs">
              BUY ANYWAY
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
